import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '../shared/material.module';
import { AddToDownloadComponent } from './components/add-to-download/add-to-download.component';
import { AlreadyInProgressDialogComponent } from './components/already-in-progress-dialog/already-in-progress-dialog.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { ButtonLoaderComponent } from './components/button-loader/button-loader.component';
import { DeleteAndCreateDialogComponent } from './components/delete-and-create-dialog/delete-and-create-dialog.component';
import { DeleteConfirmDialogComponent } from './components/delete-confirm-dialog/delete-confirm-dialog.component';
import { DownloadButtonLoaderComponent } from './components/download-button-loader/download-button-loader.component';
import { DropdownMultiselectComponent } from './components/dropdown-multiselect/dropdown-multiselect.component';
import { MultipleUploadComponent } from './components/multiple-upload/multiple-upload.component';
import { NoDataComponent } from './components/no-data/no-data.component';
import { ResolutionDialogComponent } from './components/resolution-dialog/resolution-dialog.component';
import { SectionLoaderComponent } from './components/section-loader/section-loader.component';
import { SkeltonLoaderComponent } from './components/skelton-loader/skelton-loader.component';
import { TableSkltonLoaderComponent } from './components/table-sklton-loader/table-sklton-loader.component';
import { TilesCountCardComponent } from './components/tiles-count-card/tiles-count-card.component';
import { ValidationErrorComponent } from './components/validation-error/validation-error.component';
import { VerifyMobileNumberDialogComponent } from './components/verify-mobile-number-dialog/verify-mobile-number-dialog.component';
import { ViewQrCodeDialogComponent } from './components/view-qr-code-dialog/view-qr-code-dialog.component';
import { DirectivesModule } from './directives/directives.module';
import { PipesModule } from './pipes/pipes.module';
import { PrimeNgModule } from './prime-ng.module';
import { HttpLoaderFactory } from './utils/http-loader-factory';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';
import { SkeletonModule } from 'primeng/skeleton';

@NgModule({
  declarations: [
    AddToDownloadComponent,
    AlreadyInProgressDialogComponent,
    BreadcrumbsComponent,
    ButtonLoaderComponent,
    DeleteAndCreateDialogComponent,
    DeleteConfirmDialogComponent,
    DownloadButtonLoaderComponent,
    DropdownMultiselectComponent,
    MultipleUploadComponent,
    NoDataComponent,
    SectionLoaderComponent,
    SkeltonLoaderComponent,
    TableSkltonLoaderComponent,
    ValidationErrorComponent,
    VerifyMobileNumberDialogComponent,
    ViewQrCodeDialogComponent,
    ResolutionDialogComponent,
    TilesCountCardComponent,
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule,
    HttpClientModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MaterialModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatSelectModule,
    MatTableModule,
    MatTooltipModule,
    PipesModule,
    PrimeNgModule,
    ReactiveFormsModule,
    RouterModule,
    SkeletonModule,
    QRCodeModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      extend: true,
    }),
  ],
  exports: [
    AddToDownloadComponent,
    AlreadyInProgressDialogComponent,
    BreadcrumbsComponent,
    ButtonLoaderComponent,
    CommonModule,
    DeleteAndCreateDialogComponent,
    DeleteConfirmDialogComponent,
    DirectivesModule,
    DownloadButtonLoaderComponent,
    DropdownMultiselectComponent,
    FormsModule,
    HttpClientModule,
    MaterialModule,
    MultipleUploadComponent,
    NoDataComponent,
    PipesModule,
    PrimeNgModule,
    ReactiveFormsModule,
    SectionLoaderComponent,
    SkeltonLoaderComponent,
    TableSkltonLoaderComponent,
    TranslateModule,
    ValidationErrorComponent,
    QRCodeModule,
    ViewQrCodeDialogComponent,
    TilesCountCardComponent,
  ],
})
export class SharedModule {}
